import { render } from "./QuestionObjectPhonemicVowel.vue?vue&type=template&id=3339e5ce&scoped=true"
import script from "./QuestionObjectPhonemicVowel.vue?vue&type=script&lang=js"
export * from "./QuestionObjectPhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/components/question-object-phonemic-vowel.css?vue&type=style&index=0&id=3339e5ce&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3339e5ce"]])

export default __exports__